import { Button, Text } from "@react-email/components";

export default function HighlightButton({ children, link }: { children: React.ReactNode, link: string }) {
  return (
    <Button href={link} className="bg-listflix-green-main min-w-[250px] items-center rounded-full shadow-md border-solid border-l-[32px] border-r-[32px] border-listflix-green-main border-t-[8px] border-b-[8px] text-white font-bold text-center">
      <Text className="mt-[0px] mb-[0px] text-[18px] leading-[28px] uppercase">{children}</Text>
    </Button>
  )
}